import { ArrowUpRight, Mail, MapPin, Send } from 'lucide-react'
import { useState } from 'react'

export default function Contact() {
  const [submitted, setSubmitted] = useState(false)
  const [sending, setSending] = useState(false)
  const [error, setError] = useState('')

  const handleSubmit = async (event) => {
    event.preventDefault()
    setSending(true)
    setError('')

    const form = event.currentTarget
    const payload = Object.fromEntries(new FormData(form).entries())

    try {
      const response = await fetch('/api/contact', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      })
      const result = await response.json().catch(() => ({}))

      if (!response.ok) throw new Error(result.error || 'Unable to send your enquiry.')

      form.reset()
      setSubmitted(true)
    } catch (submissionError) {
      setError(submissionError.message)
    } finally {
      setSending(false)
    }
  }

  return (
    <section className="section contact-page">
      <div className="container contact-grid">
        <div className="contact-copy">
          <span className="eyebrow">Start a conversation</span>
          <h1>Tell us what your learners need to do next.</h1>
          <p>Share your audience, goals and timeline. We’ll help shape the right program, learning depth and delivery format.</p>
          <div className="contact-details">
            <a href="mailto:hello@qubispark.com"><Mail /><span><small>Email</small>hello@qubispark.com</span><ArrowUpRight /></a>
            <div><MapPin /><span><small>Delivery</small>Canada · India · Worldwide online</span></div>
          </div>
        </div>
        <div className="contact-form-wrap">
          {submitted ? <div className="form-success"><span><Send /></span><h2>Enquiry sent.</h2><p>Thank you for contacting Qubispark. Our team will review your learning goals and follow up with you.</p><button className="button button--ghost" onClick={() => setSubmitted(false)}>Send another enquiry</button></div> :
          <form className="contact-form" onSubmit={handleSubmit}>
            <div className="form-row"><label>First name<input required name="firstName" placeholder="Your first name" /></label><label>Last name<input required name="lastName" placeholder="Your last name" /></label></div>
            <label>Work email<input required type="email" name="email" placeholder="you@organization.com" /></label>
            <label>Organization<input name="organization" placeholder="College, university or company" /></label>
            <label>I’m interested in<select required name="interest" defaultValue=""><option value="" disabled>Select an area</option><option>Student training</option><option>Faculty development</option><option>Corporate training</option><option>Taksha AI</option><option>Something else</option></select></label>
            <label>What would you like to achieve?<textarea required name="message" rows="5" placeholder="Tell us about your audience, learning goals and timeline." /></label>
            <label className="hp-field" aria-hidden="true">Website<input name="website" tabIndex="-1" autoComplete="off" /></label>
            {error && <p className="form-error" role="alert">{error}</p>}
            <button className="button" type="submit" disabled={sending}>{sending ? 'Sending…' : 'Send enquiry'} {!sending && <ArrowUpRight size={18} />}</button>
          </form>}
        </div>
      </div>
    </section>
  )
}
